import 'es6-promise/auto'
// import 'babel-polyfill'
import "core-js";

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import i18n from './i18n'
Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyAVv8qGh-5W01UjICPfK9VE-hPgswGkNp0",
  authDomain: "bakarit-test.firebaseapp.com",
  databaseURL: "https://bakarit-test.firebaseio.com",
  projectId: "bakarit-test",
  storageBucket: "bakarit-test.appspot.com",
  messagingSenderId: "1014312603041",
  appId: "1:1014312603041:web:273eddf5157c0612"
};

firebase.initializeApp(firebaseConfig);

// firebase.auth().onAuthStateChanged(() => {
//   if (!app) {
//     app = new Vue({
//       router,
//       store,
//       vuetify,
//       render: h => h(App)
//     }).$mount('#app');
//   }
// });

Vue.filter('dateString', function (value) {
  if (!value || !(typeof value.getMonth === 'function')) return value
  return value.toLocaleDateString([], { dateStyle: 'short' });
});
Vue.filter('dateTimeString', function (value) {
  if (!value || !(typeof value.getMonth === 'function')) return value
  return value.toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
});
Vue.filter('timeString', function (value) {
  if (!value || !(typeof value.getMonth === 'function')) return value
  return value.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
});
Vue.filter('kgString', function (value) {
  if (!value || isNaN(value)) return value
  return new Intl.NumberFormat().format(value) + " " + i18n.t('Kg');
});
Vue.filter('percentValue', function (value) {
  if (!value || isNaN(value)) return value
  if (value <=10) return Math.round(value*100) + " %";    //Todo: <== evaluate this - is needed?
  if (Math.abs(value) >= 100)
    return value + " %";
  else
    return value.toFixed(1) + " %";
});
Vue.filter('duration', function (value) {
  if (!value || isNaN(value)) return '00:00'
  let hr = Math.round(value / 60);
  let mn = Math.round(value % 60);
  return `${("00" + hr).slice(-2)}:${("00" + mn).slice(-2)}`
});

new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})
//.$mount('#app')
